import { BingIcon, GoogleIcon, MetaIcon } from 'components/icons'
import { PlatformIcon } from 'components/platform-icon'
import { useStores } from 'hooks'
import { LevelType } from 'layout/navbar/breadcrumbs/types'
import { Target05 as RiFocus3Line } from 'components/icons'
import { AdPlatforms, platformNameByType } from 'utils/platform'
import { RuleFormType, RuleTriggerType } from '../../../rule-form/types'
import { Globe01 as TbWorld } from 'components/icons'
export const Scope = (props: {
	rule: RuleFormType
	level: LevelType
	targetName?: string | null
	platform?: AdPlatforms
	titleClass?:string
}) => {
	const { rule, level, targetName, platform, titleClass } = props

	return (
		<div className="text-sm">
			<span className={`text-t-gray-checkout font-medium ${titleClass}`}>WHERE</span>
			<div className={`flex flex-col gap-1 mt-1 ${!titleClass && ' pl-2'}`}>
				<MainScope level={level} targetName={targetName} platform={platform} />
				<ScopeTargets level={level} trigger={rule.trigger} />
			</div>
		</div>
	)
}

const MainScope = (props: {
	level: LevelType
	platform?: AdPlatforms
	targetName?: string | null
}) => {
	const { level, targetName, platform } = props

	if (level === 'website') {
		return (
			<div className="flex items-center">
				<TbWorld className="h-4 text-t-desc-gray w-4 mr-1" /> <span className='text-t-checkbox-unactive'>Website</span>
				<strong className="font-bold text-t-checkbox-unactive ml-0.5 max-w-[200px] truncate">
					{targetName}
				</strong>
			</div>
		)
	}

	if (level === 'campaign') {
		return (
			<div className="flex items-center text-t-secondary">
				<RiFocus3Line className="h-3 w-3 mr-1" /> <span className='text-t-checkbox-unactive'>Campaign</span>
				<strong className="font-bold ml-0.5 max-w-[200px] truncate">
					{targetName}
				</strong>
			</div>
		)
	}

	return (
		<div className="flex items-center text-t-secondary">
			<PlatformIcon platform={platform} className="h-3 w-3 mr-1" />
			{platform && platformNameByType[platform]} <span className='text-t-checkbox-unactive'>Ads account</span>
			<strong className="font-bold ml-0.5 max-w-[200px] truncate">
				{targetName}
			</strong>
		</div>
	)
}

const ScopeTargets = (props: {
	level: LevelType
	trigger: RuleTriggerType
}) => {
	const { level, trigger } = props

	if (!trigger.scope_values || trigger.scope_values.length === 0) return null

	const { assetStore } = useStores()
	const { adAccounts, campaigns } = assetStore

	if (level === 'website' && trigger.scope === 'ACCOUNT') {
		const filteredAdAccounts = adAccounts.filter((a) =>
			trigger.scope_values.includes(a.id)
		)
		const gadsAccounts = filteredAdAccounts.filter((a) => a.platform === 'GADS')
		const fadsAccounts = filteredAdAccounts.filter((a) => a.platform === 'FADS')
		const badsAccounts = filteredAdAccounts.filter((a) => a.platform === 'BADS')

		return (
			<>
				{gadsAccounts.length > 0 && (
					<div className="flex items-start text-t-secondary">
						<GoogleIcon className="h-3 w-3 mr-1" />
						<span>
							Google Ads accounts{' '}
							<strong className="font-bold">
								{gadsAccounts.map((a) => a.name).join(', ')}
							</strong>
						</span>
					</div>
				)}
				{fadsAccounts.length > 0 && (
					<div className="flex items-start text-t-secondary">
						<MetaIcon className="h-3 w-3 mr-1" />
						<span>
							Meta Ads accounts{' '}
							<strong className="font-bold">
								{fadsAccounts.map((a) => a.name).join(', ')}
							</strong>
						</span>
					</div>
				)}
				{badsAccounts.length > 0 && (
					<div className="flex items-start text-t-secondary">
						<BingIcon className="h-3 w-3 mr-1" />
						<span>
							Microsoft Ads accounts{' '}
							<strong className="font-bold">
								{badsAccounts.map((a) => a.name).join(', ')}
							</strong>
						</span>
					</div>
				)}
			</>
		)
	}

	if (level === 'ad-account' && trigger.scope === 'CAMPAIGNS') {
		const filteredCampaigns = campaigns.filter((c) =>
			trigger.scope_values.includes(c.id)
		)

		return (
			<div className="flex items-start text-t-secondary">
				<RiFocus3Line className="h-3 w-3 mr-1" />
				<span>
					Campaigns{' '}
					<strong className="font-bold ml-0.5">
						{filteredCampaigns.map((a) => a.name).join(', ')}
					</strong>
				</span>
			</div>
		)
	}

	return null
}
